'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var ClaimDetailsDescription = require('../components/ClaimDetailsDescription.js');
var ClaimTypeLabel = require('../../../components/ClaimTypeLabel.js');
var Currency = require('../../../../../common/components/Currency.js');
var SessionContext = require('../../../../../common/providers/SessionContext.js');
var Box = require('../../../../../common/components/layout/Box/Box.js');
var Typography = require('../../../../../common/components/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Overview = _ref => {
  let {
    claim
  } = _ref;
  const {
    claimsClaimDetailsTitle,
    claimsClaimDetailsLabelClaimAmount,
    claimsClaimDetailsLabelClaimType,
    claimsClaimDetailsLabelCustomerComments
  } = nthHookTranslations.useTranslations();
  const {
    localeLanguage,
    localeCountry
  } = SessionContext.useSession();
  const {
    id,
    claimType,
    claimAmount,
    customerComments
  } = claim;
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 2
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: "h1"
  }, claimsClaimDetailsTitle, ` `, id), /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionList, null, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionContainer, null, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionRow, null, claimType && /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescription, {
    label: claimsClaimDetailsLabelClaimType,
    value: /*#__PURE__*/React__default["default"].createElement(ClaimTypeLabel["default"], {
      claimType: claimType
    })
  }), claimAmount && typeof claimAmount.value === 'number' && /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescription, {
    label: claimsClaimDetailsLabelClaimAmount,
    value: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Currency.Currency, {
      value: claimAmount.value,
      locale: `${localeLanguage ?? ''}_${localeCountry ?? ''}`,
      currency: claimAmount.currency
    }), claimAmount.currency && ` ${claimAmount.currency}`)
  })), customerComments && (customerComments === null || customerComments === void 0 ? void 0 : customerComments.length) > 0 && /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionRow, null, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescription, {
    label: claimsClaimDetailsLabelCustomerComments,
    value: /*#__PURE__*/React__default["default"].createElement(Box["default"], {
      gap: 1
    }, customerComments.map((comment, i) => /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, {
      key: i
    }, comment)))
  })))));
};
var Overview$1 = nthHookTranslations.withTranslationsProvider(Overview, {
  translationKeys: ['claimsClaimDetailsTitle', 'claimsClaimDetailsLabelClaimAmount', 'claimsClaimDetailsLabelClaimType', 'claimsClaimDetailsLabelCustomerComments']
});

exports["default"] = Overview$1;
